<script>
import options from './CenterMap.options'
export default options
</script>

<template>
  <article class="nyk-center-map" :class="{ 'nyk-center-map--hidden-mobile': !showMapsMobile }">
    <div class="nyk-center-map__map-search-section">
      <div class="nyk-center-map__controls">
        <div class="nyk-center-map__controls__search">
          <div class="nyk-form nyk-js--form">
            <div class="nyk-form__content">
              <input
                ref="googlePlacesSearchField"
                class="nyk-form__content__input"
                type="text"
                maxlength="10000"
                autocomplete="off"
                id="googlePlacesSearch"
                name="googlePlacesSearch"
                aria-required="true"
                @input="handleSearchInput" />

                <label for="googlePlacesSearch" class="nyk-form__content__label">{{labels.searchPlaceholderLabel}}</label>

                            <button
                                @click="resetCenterSearch"
                                class="nyk-form__content__reset-icon nyk-form-js--reset"
                                aria-label="Slet indtastning">
                                <span class="nyk-icon nyk-icon--ui-close"></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="nyk-center-map__controls__dropdown nyk-center-map__controls__dropdown--categories Form__Element">
                    <MultiSelectDropdown
                        :initOptions="multiSelectCategoriesOptions"
                        :onChangeCallback="filterCategories"
                        :placeholderLabel="labels.categorySelectPlaceholder"
                        :title="labels.titleLabel" />
                </div>

                <div v-if="localBankTypes && localBankTypes.length > 0" class="nyk-center-map__controls__dropdown Form__Element">
                    <MultiSelectDropdown
                        :initOptions="localBankTypes"
                        :onChangeCallback="filterBanks"
                        :placeholderLabel="labels.bankTypePlaceholderLabel" />
                </div>
            </div>

            <div class="nyk-center-map__switch-view-mobile">
                <div class="nyk-center-map__switch-view-mobile__body">
                    <button
                        v-on:click="handleShowMapMobile"
                        class="nyk-center-map__switch-view-mobile__body__item"
                        :class="{ 'nyk-center-map__switch-view-mobile__body__item--active': showMapsMobile }">
                        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
                            <path fill="#fff" d="M7.25 12.127 4.123 9l-1.065 1.057L7.25 14.25l9-9-1.057-1.058-7.943 7.935Z" />
                        </svg>
                        Kort
                    </button>
                    <button
                        v-on:click="handleShowListResultsMobile"
                        class="nyk-center-map__switch-view-mobile__body__item"
                        :class="{ 'nyk-center-map__switch-view-mobile__body__item--active': !showMapsMobile }">
                        Liste
                        <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
                            <path fill="#fff" d="M7.25 12.127 4.123 9l-1.065 1.057L7.25 14.25l9-9-1.057-1.058-7.943 7.935Z" />
                        </svg>
                    </button>
                </div>
            </div>

            <div class="nyk-center-map__zoom-level" aria-live="polite">Zoom level: {{ currentZoom }}</div>

            <div class="nyk-center-map__map-section">
                <div
                    class="nyk-center-map__map-section__suggestions"
                    :class="{ 'nyk-center-map__map-section__suggestions--shown': showFilteredResults }">
                    <ul class="nyk-center-map__map-section__suggestions__list">
                        <template v-for="(info, index) in centerInformationFiltered" :key="index">
                            <template v-if="index < showListMobileCount">
                                <li class="nyk-center-map__map-section__suggestions__list__item">
                                    <a class="nyk-center-map__map-section__suggestions__list__item__link" 
                                       :href="info.externalUrl || info.centerPageUrl"
                                       :target="info.externalUrl ? '_blank' : '_self'"
                                       :rel="info.externalUrl ? 'noopener noreferrer' : undefined">
                                        <div class="nyk-center-map__map-section__suggestions__list__item__link__logo">
                                            <svg v-if="!info.isSparNord" width="23px" height="27px" viewBox="0 0 23 27" xmlns="http://www.w3.org/2000/svg">
                                                <title>Nykredit</title>
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <g>
                                                        <path d="M22.5,0.5 L22.5,22.3461431 L15.6360039,22.3459953 L12.0226575,26.2626896 L8.40794026,22.3459959 L0.5,22.3461445 L0.5,0.5 L22.5,0.5 Z" stroke="#FFFFFF" fill="#0F1E82"></path>
                                                        <path d="M5.22727273,15.9652474 L5.24349469,6.3486392 C5.24349469,6.23791698 5.3573916,6.23076923 5.3573916,6.23076923 L10.405429,6.23076923 C10.5163421,6.22796992 10.5300677,6.33844754 10.5330515,6.33559387 L13.9543921,12.3483487 C13.9894307,12.4015084 14.069653,12.4287405 14.1331659,12.4043621 C14.1997478,12.3799836 14.2262613,12.2821436 14.2262613,12.2821436 L14.0828671,6.3557326 C14.0811621,6.28243416 14.0965075,6.24362431 14.1767298,6.23076923 L17.6279938,6.23076923 C17.763971,6.23076923 17.7759916,6.33265868 17.7721553,6.33004961 L17.7721553,15.932308 C17.7721553,15.932308 17.7562983,16.0600707 17.617252,16.0586846 L12.750205,16.0616455 C12.6385247,16.0616455 12.5470491,16.0600707 12.4430414,15.8990424 L9.05691001,9.8684318 C8.93073678,9.71449693 8.75417952,9.82790975 8.75417952,10.0006788 L8.94991852,15.9294543 C8.96364413,16.014249 8.88725817,16.064555 8.81308877,16.0586846 L5.34673508,16.0616455 C5.28296645,16.0629243 5.2243982,16.014249 5.22727273,15.9652474 L5.22727273,15.9652474 Z" fill="#FFFFFF"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                            <svg v-else width="30" height="39" viewBox="0 0 30 39" xmlns="http://www.w3.org/2000/svg">
                                                <title>Spar Nord</title>
                                                <rect width="29.2" height="38.4" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 15.4C25.5 15.4 27.4 15.7 29.2 16.4V0H0V38.5H7.6C6.9 36.6 6.5 34.6 6.5 32.5C6.5 23 14.1 15.4 23.5 15.4Z" fill="#BE3038"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9 33.1C26.4 33.5 26.6 34.9 27.1 35.5C27.7 36.3 28.8 37.2 28.6 37.4C28.4 37.6 27.4 36.6 26.6 36.1C24.8 35 24.3 36.1 24.2 37.1C24.1 37.8 24.1 37.9 24.1 38.5H29.3V33C28.7 33 28.2 33 27.9 33.1Z" fill="#1E427E"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8 29C25.3 29.3 25.9 29.1 26.4 28.8C27.3 28.2 27.6 28 27.7 28.1C27.8 28.2 27.4 28.6 27 29.3C26.3 30.6 26.8 31.3 27.8 31.7C28.2 31.8 28.7 31.8 29.2 31.9V19.1C27.4 18.3 25.5 17.9 23.5 17.9C15.5 17.9 9 24.4 9 32.4C9 34.6 9.5 36.6 10.3 38.4H22.9C22.9 38 22.9 37.6 22.8 37C22.8 35.9 22 35.1 20.5 36C19.5 36.6 18.6 37.6 18.4 37.4C18.2 37.2 19 36.5 19.9 35.4C20.9 34 19.8 33 18.5 32.9C15.6 32.6 14.1 32.6 14.1 32.3C14.1 32.1 16 32 18.6 31.7C20.1 31.6 20.8 30.4 19.8 29.1C19.2 28.3 18.2 27.4 18.4 27.2C18.6 27 19.3 27.8 20.3 28.5C21.1 29 21.6 29 22 28.9C22.5 28.7 22.7 28 22.7 27.7C23 25.3 23 20.5 23.4 20.5C23.8 20.5 23.9 24.8 24.2 27.7C24.3 28.5 24.5 28.8 24.8 29Z" fill="#1E427E"/>
                                            </svg>
                                        </div>
                                        <div class="nyk-center-map__map-section__suggestions__list__item__link__card">
                                            <div class="nyk-center-map__map-section__suggestions__list__item__link__card__header">
                                                <h3 class="nyk-center-map__map-section__suggestions__list__item__link__card__header__title">
                                                    {{ info.name }}
                                                </h3>
                                                <p
                                                    class="nyk-center-map__map-section__suggestions__list__item__link__card__header__address">
                                                    {{ info.address }}
                                                </p>
                                                <p
                                                    class="nyk-center-map__map-section__suggestions__list__item__link__card__header__postal-code">
                                                    {{ info.postal }}
                                                </p>
                                            </div>
                                            <!-- <div
                                              class="nyk-center-map__map-section__suggestions__list__item__link__card__distance">
                                              {{ getDistance(info) }}
                                            </div> -->
                                        </div>

                                        <div class="nyk-center-map__map-section__suggestions__list__item__arrow">
                                            <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12">
                                                <path
                                                    fill="var(--colortheme-icon)"
                                                    d="M0 5.393v1.231h11.37l-3.898 4.243.67.633L14 5.991 8.142.5l-.67.633 3.898 4.26H0Z" />
                                            </svg>
                                        </div>
                                    </a>
                                </li>
                            </template>
                        </template>
                    </ul>

                    <div
                        v-if="centerInformationFiltered && centerInformationFiltered.length > showListMobileCount"
                        class="nyk-button-container">
                        <button v-on:click="handleShowAllListMobile" class="nyk-button nyk-button--outline-primary">Vis flere</button>
                    </div>
                </div>

                <GoggleMapsWithMarkers
                    :focusPoints="focusPoints"
                    :locations="centerInformationFiltered"
                    @current-zoom="updateCurrentZoom"
                    @map-moved="handleMapMoved"
                    theme="mixedTheme"
                    :mapkey="mapkey"
                    :designSchema="designSchema"
                    :startLatitude="initialViewportLat ?? undefined"
                    :startLongitude="initialViewportLng ?? undefined"
                    :startZoom="initialViewportZoom ?? undefined" />
            </div>
        </div>
    </article>
</template>
